import { render, staticRenderFns } from "./MyReportItem.vue?vue&type=template&id=c06ab1fa&"
import script from "./MyReportItem.vue?vue&type=script&lang=js&"
export * from "./MyReportItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports